import { ConnectedRouter } from 'connected-react-router'
import { history } from '../redux'

export const withConnectedRouter = (component: () => React.ReactNode) => () => {
  return <ConnectedRouter history={history}>{component()}</ConnectedRouter>
}
